import { featuredItems } from "@/mocks/jiuse";

const heroCover =
  "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20of%20a%20glowing%20phone%20screen%20illuminating%20newspaper%20clippings%20and%20scattered%20photo%20prints%20on%20a%20warm%20desk%20with%20dramatic%20chiaroscuro%20lighting%20deep%20amber%20and%20crimson%20tones%20and%20cinematic%20shallow%20depth%20of%20field%20and%20vintage%20print%20texture&width=960&height=1120&seq=jiuse-hero&orientation=portrait";

export default function Hero() {
  return (
    <section id="headline" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:px-6 lg:grid-cols-[1.35fr_1fr] lg:py-16">
        {/* 文案为主 */}
        <div className="flex flex-col justify-center">
          <div className="mb-5 inline-flex w-fit items-center gap-3">
            <span className="h-5 w-1 rounded-full bg-primary-500" aria-hidden="true" />
            <span className="text-xs font-semibold tracking-[0.28em] text-primary-700">本期头版 · 2026</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.18]">
            九色黑料图片、九色黑料视频
            <span className="text-primary-600">已按页面分好</span>，
            <br className="hidden md:block" />
            点开就能看原图级画面。
          </h2>
          <p className="mt-6 max-w-xl text-[15px] leading-8 text-foreground-700">
            无论是九色黑料截图、照片还是视频细节，都按题材与日期归档成独立分区。想找某一页的画面，直接翻对应专区即可，不必再在整屏内容里来回滑动。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#gallery"
              className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-center text-sm font-semibold text-background-50 transition hover:bg-primary-700"
            >
              开始翻原图专区
            </a>
            <a
              href="#timeline"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-center text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              查看流出时间线
            </a>
          </div>
          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px] text-foreground-500">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-time-line text-primary-600" aria-hidden="true" /> 今日已更新 2 批
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-archive-2-line text-primary-600" aria-hidden="true" /> 9 大分区
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-fire-fill text-accent-500" aria-hidden="true" /> 原图级画面持续流出
            </span>
          </div>
        </div>

        {/* 视觉陪衬 */}
        <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
          <div className="absolute -right-2 -top-2 hidden h-full w-full rounded-lg border border-primary-200 sm:block" aria-hidden="true" />
          <div className="relative overflow-hidden rounded-lg bg-background-100">
            <img
              src={heroCover}
              alt="九色黑料原图资料归档封面"
              title="九色黑料图片资料"
              className="h-[420px] w-full object-cover md:h-[520px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent" aria-hidden="true" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-background-50">
              <span className="font-display text-sm tracking-wide">头版 · 归档封面</span>
              <span className="flex items-center gap-1 text-xs"><i className="ri-zoom-in-line" aria-hidden="true" />原图级</span>
            </div>
          </div>
        </div>
      </div>

      {/* 今日要闻 · 标题+短摘要列表 */}
      <div className="border-y border-background-200 bg-background-100/60">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-x-10 gap-y-6 px-4 py-7 md:grid-cols-3 md:px-6">
          {featuredItems.map((it, idx) => (
            <article key={idx} className={idx === 0 ? "border-b border-background-200 pb-5 md:border-b-0 md:pb-0 md:pr-6 md:border-r" : "border-b border-background-200 pb-5 last:border-b-0 md:border-b-0 md:pb-0 md:pl-2"}>
              <div className="mb-2 flex items-center gap-2">
                {it.tag && <span className="rounded-full bg-primary-600 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">{it.tag}</span>}
                <span className="text-[11px] text-foreground-500">{it.meta}</span>
              </div>
              <h3 className="font-display text-[17px] font-bold leading-snug text-foreground-950 transition hover:text-primary-700">
                <a href="#headline">{it.title}</a>
              </h3>
              <p className="mt-2 text-[13px] leading-6 text-foreground-600">{it.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}